<template>
    <div class="reset-page">
    <div class="loging-ready">
            <div class="input-content">
                <div class="reset-text">重置密码</div>
                <el-form :model="forgetForm" ref="ResetForm" :rules="rules">
                    <el-form-item prop="password1">
                        <div class="login-account-input" style="margin-top: 16px;">
                            <el-input v-model="forgetForm.password1" placeholder="请输入新密码" :type="passw">
                                <i slot="suffix" v-if="passw==='password'">
                                    <img src='../../../static/images/login/hidden.png' @click="showPass" class="pwd-eyes">
                                </i>
                                <i slot="suffix" v-else>
                                    <img src='../../../static/images/login/visible.png' @click="showPass" class="pwd-eyes">
                                </i>
                            </el-input>
                        </div>
                    </el-form-item>
                    <el-form-item prop="password2">
                        <div class="login-account-input" style="margin-top: 16px;">
                            <el-input v-model="forgetForm.password2" placeholder="请再次输入新密码" :type="passw">
                                <i slot="suffix" v-if="passw == 'password'">
                                    <img src='../../../static/images/login/hidden.png' @click="showPass" class="pwd-eyes">
                                </i>
                                <i slot="suffix" v-else>
                                    <img src='../../../static/images/login/visible.png' @click="showPass" class="pwd-eyes">
                                </i>
                            </el-input>
                        </div>
                    </el-form-item>
                </el-form>
                <div class="login-button" style="margin-top: 16px;">
                    <el-button  type="primary" style="font-size: 16px; width: 100%;" @click="onClicKSend">重   置</el-button>
                </div>
            </div>
        </div>
    </div>
    </template>

<script>

export default {
    name: 'ResetPassword',
    data(){
        return {
            forgetForm:{
                password1:'',
                password2:'',
            },
            userId:'',
            validate :false,
            currentCode: '',
            passw: 'password',
            rules:{
                password1:[{
                    required:true,message:'请输入新密码',trigger: "blur"
                }],
                password2:[{
                    required:true,message:'',trigger: "blur",validator:this.samePasswordCheck
                }]
            }
        }
    },
    mounted(){
        let code = this.$route.query.code
        this.currentCode = code 
        this.checkCodeValidate(code)
    },
    methods:{
         //密码的隐藏和显示
        showPass(){
            //点击图标是密码隐藏或显示
            if (this.passw == "text") {
                this.passw = "password";
            } else {
                this.passw = "text";
            }
        },
        samePasswordCheck(rule,value,callback){
            if(value == ''){
                return callback(new Error('请再次输入新密码'))
            }
            if (this.forgetForm.password1  != value) {
                return callback(new Error('两次密码输入不一致'))
            }
            callback()
        },
        checkCodeValidate(code){
            this.validate = false
            this.$request.get('/user/validatePswEmail',{code:code} ,false).then(response=>{
                // console.log('校验code。',response)
                if(response.data.code == 200){
                    this.validate = true
                    this.userId = response.data.data.userId

                }else {
                    this.$toastError('链接已失效，请重试')
                }
            }).catch(err=>{
                console.log('校验code。',err)
            })
        },
        onClicKSend(){
            
            this.$refs.ResetForm.validate(pass=>{
                if(pass){
                    this.doSend()
                }
            })

        },
        doSend(){
            if(this.validate == false || this.currentCode == ''){
                this.$toastError('链接无效，请重试')
                return;
            }
            let params = {
                code: this.currentCode,
                password: this.forgetForm.password1,
                oldPsw:"",
                userId: this.userId
            }
            this.$request.postnotAuthor('/user/resetPsw',{},params,false).then(response=>{
                // console.log('修改密码：',response)
                if(response.data.code == 200){
                    this.$toastSuccess('修改成功')
                    // this.$router.push({ name: "Login", params: { type: 'login' } }).catch(err => {
                    //     // console.log(err)
                    //     // console.log('跳转失败！')
                    // })
                    this.$bus.$emit('OPEN_LOGIN_DIALOG')
                }else {
                    this.$toastError('修改失败')
                }
            }).catch(err=>{
                // console.log('修改密码：err',err)
                this.$toastError('修改失败')
            })

        }
    }
}
</script>

<!-- 使用相同的样式 -->
<style src="../../../static/css/login_input.css" scoped></style> 
<style scoped>
    .reset-page{
        display:flex; 
        width: 100%; 
        height: 100%; 
        align-items: center; 
        justify-content: center;
        background: linear-gradient(0deg, #00A1FE 0%, #97D9FF 100%);
    }
    .pwd-eyes{
        width: 32px;
        height:32px;
        cursor:pointer;
        z-index:100;
        margin-top:16px;
        margin-right: 8px;
    }
    .loging-ready{
        width: calc(604px * 1);
        height: calc(480px * 1);
        border-radius: 20px;
        background-color: white;
        border: 1px #00A1FE solid;
        display: flex;
        justify-content: center;
        
    }
</style>


// WEBPACK FOOTER //
// src/views/login/ResetPassword.vue